import React, { useState, useEffect } from "react"
import { Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from "recharts"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import { URLS } from "../../Url"
import axios from "axios"

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"]

const Dashboard = () => {
  const GetAuth = localStorage.getItem("authUser")
  const TokenJson = JSON.parse(GetAuth)
  const TokenData = TokenJson.token

  const [TopCategories, setTopCategories] = useState([])

  useEffect(() => {
    getDashboardData()
  }, [])

  const getDashboardData = () => {
    const token = TokenData
    axios
      .post(
        URLS.GetDashboard,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setTopCategories(res?.data?.topCategories || [])
      })
      .catch(error => {
        console.error("Error fetching dashboard data:", error)
      })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="mb-3">
            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <h2 className="font-semibold mb-2">Top Categories</h2>
                    <ResponsiveContainer width="100%" height={300}>
                      <PieChart>
                        <Pie
                          data={TopCategories}
                          dataKey="value"
                          cx="50%"
                          cy="50%"
                          outerRadius={70}
                          fill="#8884d8"
                          label
                        >
                          {TopCategories.map((entry, index) => (
                            <Cell
                              key={index}
                              fill={COLORS[index % COLORS.length]}
                            />
                          ))}
                        </Pie>
                        <Tooltip />
                      </PieChart>
                    </ResponsiveContainer>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Dashboard
